<template>
  <v-hover>
    <v-responsive slot-scope="{ hover }" height="100%">
      <vc-share-a
        :href="linkUrl"
        v-bind="{ target: targetBlank ? '_blank' : '_self' }"
      >
        <v-img :src="imgSrc">
          <div
            v-if="hover"
            class="d-flex transition-fast-in-fast-out"
            style="height: 100%;"
            :style="{ 'background-color': 'rgba(255,255,255,0.5)' }"
          ></div>
        </v-img>
      </vc-share-a>
    </v-responsive>
  </v-hover>
</template>

<script>
export default {
  name: "vc-share-image-with-hover-event",
  props: {
    imgSrc: {
      type: String,
      default: ""
    },
    linkUrl: {
      type: String,
      default: ""
    },
    targetBlank: {
      type: Boolean,
      default: false
    }
  }
};
</script>
